import React, { ReactNode, useEffect, useState } from "react";
import { Option } from "@/interfaces/Option";

type DropDownProps = {
  isDropdown: boolean;
  dataTestID: string;
  toggleDropdown: () => void;
  children: ReactNode;
  valueOfField: string[];
  optionList: Option[];
  id?: string;
};

const DropDown: React.FC<DropDownProps> = ({
  isDropdown,
  dataTestID,
  toggleDropdown,
  children,
  valueOfField,
  optionList,
  id,
}) => {
  const [valueDisplay, setValueDisplay] = useState("Select");

  useEffect(() => {
    if (valueOfField.length === 0) {
      setValueDisplay("Select");
    } else if (valueOfField.length === optionList.length) {
      setValueDisplay("All");
    } else {
      const display = valueOfField.join(", ").toUpperCase();
      setValueDisplay(display);
    }
  }, [optionList, valueOfField]);
  return (
    <div
      id="dropdown-container"
      data-testid={dataTestID}
      className={`relative bg-gray-125 cursor-default border-solid border-b-2 rounded mx-2 block w-full
      ${isDropdown ? "border-CostcoAction-focus" : "border-gray-500"}`}
    >
      <button
        onClick={toggleDropdown}
        id={id || "dropdown-toggle"}
        data-testid={id || "dropdown-toggle"}
        className="flex w-full justify-between select-none items-center control--compact"
      >
        <div className="w-[80%] text-left truncate">{valueDisplay}</div>
        <div
          id="dropdown-toggle-icon"
          className={`text-CostcoAction text-2xl ${
            isDropdown ? "icon-arrow_drop_up" : "icon-arrow_drop_down"
          }`}
        />
      </button>
      {isDropdown && (
        <div className="absolute p-1 t-100% mt-1 bg-gray-125 z-10 w-full max-h-[500px] overflow-y-auto shadow-md">
          {children}
        </div>
      )}
    </div>
  );
};

export default DropDown;
